const selectFormFillData = state => state.data.formFillData

const FormFillDataDataStoreSelectors = {
  formFillData: selectFormFillData
}

export default FormFillDataDataStoreSelectors
